import { handleExcludesUrlRegExps } from '../token-base';
import { PRESETS_TOKEN_BASE_PATENT_VIEW } from "library-@/token-base/presets";
import qs from 'qs';
import { set, get, forEach, camelCase } from 'lodash';

const isFreeViewJudgmentTag = 'IS_FREE_VIEW';
const freeViewSignRequestHeaderList = [
    'X-Verify-View-Share-Id',
    'X-Verify-View-Expire',
    'X-Verify-View-Signature',
    'X-Verify-View-Date',
    'X-Verify-View-From',
    'X-Verify-View-Version'
]

const getTransPath = (origin, trans) => {
    const splitFullPath = origin.split('//');
    const protocol = splitFullPath.length > 1 ? splitFullPath[0] : '';
    const splitPath = splitFullPath[1].split('/');
    const domain = splitPath[0];
    const path = splitPath.filter((item, index) => index !== 0).join('/');
    return `${protocol}//${domain}${trans}/${path}`;
};

export const freeViewRequestSuccessInterceptor = config => {
    const isFreeView = true;
    const freePath = '/free-share';

    config.headers['X-PatSnap-From'] = `w-analytics-${PRESETS_TOKEN_BASE_PATENT_VIEW.name}`;
    config.headers = {
        ...config.headers
    };

    if (/\/node-internal\/.+/.test(config.url)) {
        if (isFreeView) {
            if (!config.url.startsWith('//') && !config.url.startsWith('http')) {
                config.url = `${freePath}/node-internal${config.url}`;
            } else {
                config.url = getTransPath(config.url, `${freePath}/node-internal`);
            }
        }
        return config;
    };

    const excludesUrlConfig = handleExcludesUrlRegExps({
        config,
        excludesUrlRegExps: PRESETS_TOKEN_BASE_PATENT_VIEW.excludesUrlRegExps,
        apiVersion: PRESETS_TOKEN_BASE_PATENT_VIEW.apiVersion
    });

    if (excludesUrlConfig) {
        if (isFreeView && excludesUrlConfig && excludesUrlConfig.url) {
            if (!excludesUrlConfig.url.startsWith('//') && !excludesUrlConfig.url.startsWith('http')) {
                excludesUrlConfig.url = `${freePath}${excludesUrlConfig.url}`;
            } else {
                excludesUrlConfig.url = getTransPath(excludesUrlConfig.url, freePath);
            }
        }
        return excludesUrlConfig;
    };

    if (isFreeView) {
        if (!config.url.startsWith('//') && !config.url.startsWith('http')) {
            config.url = `${freePath}/node-internal${config.url}`;
        } else {
            config.url = getTransPath(config.url, `${freePath}/node-internal`);
        }
    } else {
        if (!config.url.startsWith('//') && !config.url.startsWith('http')) {
            config.url = `/node-internal${config.url}`;
        } else {
            config.url = getTransPath(config.url, `/node-internal`);
        }
    }
    return config;
};

export const freeViewRequestSignInterceptor = config => {
    let params = qs.parse(window.location.search.replace(/\?/, ''));
    params = Object.assign({}, params, {
        // 兼容老的如邮件模版里面的from参数
        from: params.shareFrom || params.from,
    });
    forEach(freeViewSignRequestHeaderList, header => {
        const key = camelCase(header.replace(/X-Verify-View-/, ''));
        const value = get(params, key);
        if (value) {
            config.headers[header] = value;
        }
    })

    config.headers = {
        ...config.headers
    };
    return config;
}

export const setIsFreeView = val => {
    set(window, isFreeViewJudgmentTag, val);
};

export const getIsFreeView = () => {
    return get(window, isFreeViewJudgmentTag, false);
};
